import { Invoice } from '../dtos';
import {
  API_INVOICES_PATH, getClient,
} from '../api';
import { serializeParams } from '../utils/serializer';
import { PaginatedResult, PaginationParams, serializePagination } from '../../pagination';
import { CreateProviderFunction, UpdateProviderFunction } from '../types';

export interface InvoicesProviderFilters {
  assignmentId?: number;
  reference?: string;
  propertyId?: number;
}

export async function getInvoices(
  filters: InvoicesProviderFilters = {},
  pagination: PaginationParams = { size: 20 },
): Promise<PaginatedResult<Invoice>> {
  const client = await getClient();
  const { data } = await client.get<PaginatedResult<Invoice>>(API_INVOICES_PATH, {
    params: {
      ...serializeParams(filters),
      ...serializePagination(pagination),
    },
  });

  return data;
}

export async function getInvoice(id: number): Promise<Invoice> {
  const client = await getClient();
  const { data } = await client.get<Invoice>(`${API_INVOICES_PATH}/${id}`);

  return data;
}

export const createInvoice: CreateProviderFunction<Invoice> = async (invoice) => {
  const client = await getClient();
  const { data } = await client.post<Invoice & { id: NonNullable<Invoice['id']> }>(API_INVOICES_PATH, invoice);

  return data;
};

export const updateInvoice: UpdateProviderFunction<Invoice> = async (invoiceId, invoice) => {
  const client = await getClient();
  const { data } = await client.put<Invoice & { id: NonNullable<Invoice['id']> }>(`${API_INVOICES_PATH}/${invoiceId}`, invoice);

  return data;
};

export const deleteInvoice = async (invoiceId: NonNullable<Invoice['id']>) => {
  const client = await getClient();

  await client.delete(`${API_INVOICES_PATH}/${invoiceId}`);
};
